export default "__VITE_ASSET__ap9Waziz__"